// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"e56756fd","946":"6d230093"}[chunkId] + ".chunk.css";
};